import React, { useState, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Preloader from "../components/Preloader";

//Custom Components

import Home from "../pages/home";
import HomeTwo from "../pages/home-2";
import HomeThree from "../pages/home-3";
import About from "../pages/about";
import Course from "../pages/course";
import CourseList from "../pages/course/course-list";
import CourseDetails from "../pages/course/course-details";
import CourseSidebar from "../pages/course/course-sidebar";
import Instructor from "../pages/instructor";
import InstructorDetails from "../pages/instructor/instructor-details";
import Event from "../pages/event";
import EventSidebar from "../pages/event/event-sidebar";
import EventDetails from "../pages/event/event-details";
import Blog from "../pages/blog";
import BlogDetails from "../pages/blog/blog-details";
import Login from "../pages/authentication/login";
import Signup from "../pages/authentication/signup";
import Contact from "../pages/contact";
import Error from "../pages/404";
import LoadTop from "../components/ScrollTop/LoadTop";
import Upsc from "../pages/upsc";
import UpscEligibility from "../pages/upsc-eligibility";
import ExamPattern from "../pages/exam-pattern";
import PrelimsSyllabus from "../pages/prelims-syllabus";
import MainsSyllabus from "../pages/mains-syllabus";
import UpscCalender from "../pages/calender";
import UpscResources from "../pages/upsc-resources";
import QuestionPapers from "../pages/question-papers";
import CurrentAffairs from "../pages/current-affairs";
import PrelimsTestSeries from "../pages/prelims-test-series";
import MainsTestSeries from "../pages/mains-test-series";
import OfficersPanel from "../pages/officers-panel";
import Testimonials from "../pages/testimonials";
import UpscBooks from "../pages/upsc-books";
import UpscResourcesDetails from "../pages/upsc-resources/UpscResourcesDetails";
import QuizList from "../pages/current-affairs/quiz-list/QuizList";
import MonthlyMagazine from "../pages/current-affairs/monthly-current-affairs/monthly-current-affairs";
import Quiz from "../pages/current-affairs/quiz/quiz";
import LegalDisclaimer from "../pages/legal-disclaimer";
import InvoiceWrapper from "../pages/invoice/invoice-wrapper";
import QuizForm from "../pages/quiz-form/quiz-form";
import MediaOutreachPage from "../pages/media-outreach/media-outreach";

const App = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false); // Track authentication

  const navigate = useNavigate(); // Hook to programmatically navigate

  useEffect(() => {
    // Simulate data loading delay
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  const handleLogin = (email, password) => {
    // Simple hardcoded login check for demo
    if (email === "adminjnani" && password === "jnani@petrao") {
      setIsAuthenticated(true); // Set authentication state to true
      navigate("/invoice"); // Redirect to invoice after successful login
    } else {
      alert("Invalid username or password.");
    }
  };

  return (
    <div className="App">
      {isLoading ? <Preloader /> : ""}
      <>
        <LoadTop />
        <Routes>
          <Route path="/" exact element={<Home />} />
          {/* <Route path="/home-2" element={<HomeTwo />} />
                    <Route path="/home-3" element={<HomeThree />} /> */}
          <Route path="/about" element={<About />} />
          <Route path="/upsc-eligibility" element={<UpscEligibility />} />
          <Route path="/exam-pattern" element={<ExamPattern />} />
          <Route path="/prelims-syllabus" element={<PrelimsSyllabus />} />
          <Route path="/mains-syllabus" element={<MainsSyllabus />} />
          <Route path="/calender" element={<UpscCalender />} />
          <Route path="/upsc-resources" element={<UpscResources />} />
          <Route
            path="/upsc-resources/:id"
            element={<UpscResourcesDetails />}
          />
          <Route path="/question-papers" element={<QuestionPapers />} />
          <Route path="/current-affairs" element={<CurrentAffairs />} />
          <Route
            path="/monthly-current-affairs"
            element={<MonthlyMagazine />}
          />
          <Route path="/current-affairs-quiz" element={<QuizList />} />
          <Route path="/current-affairs-quiz/:quizId" element={<Quiz />} />
          <Route path="/prelims-test-series" element={<PrelimsTestSeries />} />
          <Route path="/mains-test-series" element={<MainsTestSeries />} />
          <Route path="/officers-panel" element={<OfficersPanel />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/legal-disclaimer" element={<LegalDisclaimer />} />
          <Route path="/upsc" element={<Upsc />} />
          <Route path="/course" exact element={<Course />} />
          <Route path="/course-list" exact element={<CourseList />} />
          <Route path="/course/:id" element={<CourseDetails />} />
          <Route path="/books" element={<UpscBooks />} />
          <Route path="/course-sidebar" element={<CourseSidebar />} />
          <Route path="/event" exact element={<Event />} />
          <Route path="/event/:id" element={<EventDetails />} />
          <Route path="/event-sidebar" element={<EventSidebar />} />
          <Route path="/blog" exact element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetails />} />
          <Route path="/instructor" exact element={<Instructor />} />
          <Route path="/instructor/:id" exact element={<InstructorDetails />} />
          <Route path="/media-outreach" element={<MediaOutreachPage />} />

          <Route path="/quiz-form-jnani" exact element={<QuizForm />} />

          {/* <Route path="/signup" element={<Signup />} /> */}
          {/* Admin Login Route */}
          <Route
            path="/admin-login"
            element={<Login onLogin={handleLogin} />}
          />

          {/* Protected Invoice Route */}
          {isAuthenticated && (
            <Route
              path="/invoice"
              element={
                isAuthenticated ? (
                  <InvoiceWrapper />
                ) : (
                  <Login onLogin={handleLogin} />
                )
              }
            />
          )}

          <Route path="/contact" element={<Contact />} />

          <Route path="*" element={<Error />} />
        </Routes>
      </>
    </div>
  );
};

export default App;
